import { useAuth } from "../../context/Auth";
import {
  LockIcon,
  NavbarArrowDownDarkIcon,
  NavbarArrowDownIcon,
  NavbarFullScreenIcon,
  NavbarNotificationDarkIcon,
  NavbarNotificationIcon,
  NavbarSaleOrderDarkIcon,
  NavbarSaleOrderIcon,
  NavbarSearchDarkIcon,
  NavbarSearchIcon,
  NavbarSunDarkIcon,
  NavbarSunIcon,
  SearchSmall,
} from "../../icons/Icon";
import styles from "./Navbar.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useEffect, useState } from "react";
import { MenuIconLight } from "../../icons/Icon2";
import Drawer from "./Drawer";
import { formatPath } from "../Hooks/GetUrlPath";
import { useBranding } from "../../context/BrandingContext";

const Navbar = ({
  isTogle,
  isDrawerOpen,
  toggleDrawer,
  menuItems,
  defaultDashboard,
}) => {
  const {
    mode,
    setMode,
    designations,
    setOpenSearchModal,
    handleSignOut,
    loggedIn,
    // settingsData,
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { branding } = useBranding();
  const [time, setTime] = useState(() => {
    const storedTime = localStorage.getItem("loginTime");
    return storedTime ? Math.floor((Date.now() - storedTime) / 1000) : 0;
  });

  useEffect(() => {
    if (!loggedIn || time >= 10) return;

    const interval = setInterval(() => {
      const storedTime = localStorage.getItem("loginTime");
      if (storedTime) {
        const newTime = Math.floor((Date.now() - storedTime) / 1000);
        setTime(newTime);
        if (newTime >= 10) {
          clearInterval(interval);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [loggedIn, time]);

  const activeOnEnter = loggedIn ? time > 0 && time < 10 : time < 10;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        designations.includes("superadmin") &&
        loggedIn &&
        activeOnEnter &&
        location.pathname === "/dashboard"
      ) {
        if (event?.key === "Enter") {
          event.preventDefault();
          setOpenSearchModal(true);
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    activeOnEnter,
    designations,
    location.pathname,
    loggedIn,
    setOpenSearchModal,
  ]);

  useEffect(() => {
    if (window?.location?.pathname === "/") {
      navigate(defaultDashboard);
    }
  }, [defaultDashboard, navigate]);

  const encryptedName = sessionStorage.getItem("name")
    ? sessionStorage.getItem("name")
    : "";
  const decryptedBytes = CryptoJS.AES.decrypt(encryptedName, "secret key");
  const name = decryptedBytes.toString(CryptoJS.enc.Utf8);

  const dAarray = [];

  const encryptedDesignations = sessionStorage.getItem("designations")
    ? sessionStorage.getItem("designations")
    : "";
  const decryptedDesignations = CryptoJS.AES.decrypt(
    encryptedDesignations,
    "secret key",
  );
  const designationss = decryptedDesignations.toString(CryptoJS.enc.Utf8);
  designationss.split(",").forEach((element) => {
    dAarray.push({ designation: element });
  });

  function toggle_full_screen() {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT,
        );
      } else if (document.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }

  const icons = {
    search: mode ? <NavbarSearchDarkIcon /> : <NavbarSearchIcon />,
    sun: mode ? <NavbarSunDarkIcon /> : <NavbarSunIcon />,
    notification: mode ? (
      <NavbarNotificationDarkIcon />
    ) : (
      <NavbarNotificationIcon />
    ),
    saleOrder: mode ? <NavbarSaleOrderDarkIcon /> : <NavbarSaleOrderIcon />,
    fullScreen: <NavbarFullScreenIcon color={mode ? "#ffffff" : "#646B88"} />,
    arrowDown: mode ? <NavbarArrowDownDarkIcon /> : <NavbarArrowDownIcon />,
    LogOutIcon: <LockIcon color={mode ? "#FFFFFF" : "#646B88"} />,
  };

  const darkModeStyles = {
    navbar: mode ? { backgroundColor: "#2C2E33" } : {},
    searchBar: mode ? { backgroundColor: "#1B1D21" } : {},
    profileSection: mode ? { backgroundColor: "#232529" } : {},
    text: mode ? { color: "#fff" } : {},
  };

  return (
    <div
      className={isTogle ? styles.navbar1 : styles.navbar}
      style={darkModeStyles.navbar}
    >
      {/* <h2 style={darkModeStyles.text} className={styles.txt}>WALLICON</h2> */}
      <h2 style={darkModeStyles.text} className={styles.txt}>
        {/* {settingsData?.projectName}{" "} */}
        {branding?.title}{" "}
      </h2>

      <div className={styles.navbar_Right}>
        <div className={styles.navbar_Links}>
          {designations.includes("superadmin") && (
            <div
              className={`${styles.nav_search} ${
                activeOnEnter && location.pathname === "/dashboard"
                  ? styles.animate_border
                  : ""
              }`}
              style={mode ? { backgroundColor: "#232529" } : {}}
              onClick={() => setOpenSearchModal(true)}
            >
              <SearchSmall color={mode ? "#FFFFFF" : "#646b88"} />
              <p style={mode ? { color: "#FFFFFF" } : {}}>CTRL + K</p>
            </div>
          )}

          <div>{icons.notification}</div>
          {(designations.includes("superadmin") ||
            designations.includes("inventorymanager") ||
            designations.includes("ordermanager")) && (
            <div onClick={() => navigate("/orders/order/saleorder")}>
              {icons.saleOrder}
            </div>
          )}
          <div
            onClick={() => {
              toggle_full_screen();
            }}
          >
            {icons.fullScreen}
          </div>
        </div>

        <div
          className={styles.navbar_Profile_Section}
          style={darkModeStyles.profileSection}
          onClick={() => navigate("/profile")}
        >
          <div
            className={styles.first_name}
            style={{ color: mode ? "#fff" : "#000" }}
          >
            {name.charAt(0).toUpperCase()}
          </div>
          <p style={darkModeStyles.text}>{name}</p>
        </div>
        <div
          onClick={handleSignOut}
          style={{ marginLeft: "20px", cursor: "pointer" }}
        >
          {icons.LogOutIcon}
        </div>
      </div>

      <div className={styles.md_continer}>
        <div onClick={toggleDrawer}>
          <MenuIconLight mode={mode} />
        </div>
        <div className={mode ? styles.md_menu_text_dark : styles.md_menu_text}>
          <span>{formatPath(window?.location?.pathname)}</span>
        </div>
        <div className={styles.md_image} onClick={() => setMode(!mode)}>
          <img
            src="./assets/updatedAssets/pfp.png"
            alt=""
            className={styles.main_Image}
          />
        </div>
        <Drawer
          isOpen={isDrawerOpen}
          onClose={toggleDrawer}
          menuItems={menuItems}
        />
      </div>
    </div>
  );
};

export default Navbar;
